var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScalpFever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10904_32439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 51.1202C20.7766 51.1202 16.0966 50.1202 13.1166 47.8102C11.9766 46.9202 9.80664 48.5902 7.98664 46.1302C5.55664 42.8302 6.40661 39.4602 8.07661 38.5602C10.0766 37.4902 11.8166 39.7702 11.8166 39.7702C8.8666 23.0502 15.6666 12.7002 30.6666 12.7002C45.6666 12.7002 52.4666 23.0502 49.5166 39.7702C49.5166 39.7702 51.2667 37.4902 53.2567 38.5602C54.9267 39.4602 55.7766 42.8302 53.3466 46.1302C51.5266 48.5902 49.3466 46.9202 48.2166 47.8102C45.1966 50.1602 40.5566 51.1202 30.6666 51.1202Z",
    fill: "url(#paint0_linear_10904_32439)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10904_32439",
    x1: 30.6666,
    y1: 51.1202,
    x2: 30.6666,
    y2: 12.7102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68673"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10904_32439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.666626 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalpFever);
export default __webpack_public_path__ + "static/media/scalp-fever.0e0f8246299b42702274c88e590dc7e4.svg";
export { ForwardRef as ReactComponent };